import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["searchString", "searchResult", "onSelectTemplate", "isSearching", "statusMessages", "activeIndex", "onItemHover"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Text, LazyImage } from '@miro-site/core';
import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import SearchResultItem from './SearchResultItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Wrapper = styled.div.withConfig({
  displayName: "SearchDropdown__Wrapper",
  componentId: "sc-92rynn-0"
})(["border-top:1px solid var(--wcds-colors-gray-30);display:flex;flex-direction:row;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    paddingLeft: [null, 26, 26, 26],
    paddingRight: [null, 26, 26, 26]
  });
});
var List = styled(Box).attrs({
  as: 'ul'
}).withConfig({
  displayName: "SearchDropdown__List",
  componentId: "sc-92rynn-1"
})(["width:100%;overflow-y:auto;", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.normalizeStyles({
    paddingBottom: 18,
    paddingRight: [null, 52],
    paddingTop: 18,
    borderRight: ['none', '1px solid var(--wcds-colors-gray-30)'],
    maxHeight: 288
  });
});
var Preview = styled.a.withConfig({
  displayName: "SearchDropdown__Preview",
  componentId: "sc-92rynn-2"
})(["", " &:hover{", "{transition:color ", ";color:", ";}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.normalizeStyles({
    paddingBottom: 40,
    paddingLeft: 60,
    paddingTop: 40,
    width: 388,
    display: ['none', 'block', 'block', 'block']
  });
}, Text, function (_ref4) {
  var theme = _ref4.theme;
  return theme.animation.transitionDuration;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primaryBlueHover;
});
var NoResult = styled.div.withConfig({
  displayName: "SearchDropdown__NoResult",
  componentId: "sc-92rynn-3"
})(["color:var(--wcds-colors-indigo-50);", ""], function (_ref6) {
  var theme = _ref6.theme;
  return theme.normalizeStyles({
    paddingLeft: [10, 34, 34, 34],
    paddingRight: [10, 34, 34, 34],
    paddingTop: 24,
    paddingBottom: 24,
    fontSize: 18,
    lineHeight: 20
  });
});

var SearchDropdown = function SearchDropdown(_ref7) {
  var _ref7$searchString = _ref7.searchString,
      searchString = _ref7$searchString === void 0 ? '' : _ref7$searchString,
      _ref7$searchResult = _ref7.searchResult,
      searchResult = _ref7$searchResult === void 0 ? [] : _ref7$searchResult,
      onSelectTemplate = _ref7.onSelectTemplate,
      isSearching = _ref7.isSearching,
      statusMessages = _ref7.statusMessages,
      activeIndex = _ref7.activeIndex,
      onItemHover = _ref7.onItemHover,
      props = _objectWithoutProperties(_ref7, _excluded);

  var _useState = useState(0),
      selectedItem = _useState[0],
      setSelectedItem = _useState[1];

  var list = useRef(null);
  var listItem = useRef(null);

  var scrollToTop = function scrollToTop() {
    var _listItem$current, _listItem$current2;

    var elHeight = typeof ((_listItem$current = listItem.current) === null || _listItem$current === void 0 ? void 0 : _listItem$current.clientHeight) !== 'undefined' ? (_listItem$current2 = listItem.current) === null || _listItem$current2 === void 0 ? void 0 : _listItem$current2.clientHeight : 0;
    var elOffset = elHeight * activeIndex;
    if (list.current) list.current.scrollTop = elOffset;
  };

  var _useState2 = useState(false),
      scrollOff = _useState2[0],
      setScrollOff = _useState2[1];

  useEffect(function () {
    if (selectedItem > 0) {
      setSelectedItem(0);
    }
  }, [searchString]);
  useEffect(function () {
    setSelectedItem(activeIndex);
    if (!scrollOff) scrollToTop();
  }, [activeIndex]);

  if (!props.open) {
    return null;
  }

  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [searchResult.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(List, {
        ref: list,
        children: searchResult.map(function (value, index) {
          return /*#__PURE__*/_jsx("li", {
            ref: listItem,
            children: /*#__PURE__*/_jsx(SearchResultItem, _objectSpread({
              isActive: selectedItem === index,
              onSelectTemplate: onSelectTemplate,
              onMouseEnter: function onMouseEnter() {
                setScrollOff(true);
                if (typeof onItemHover !== 'undefined') onItemHover(index);
              },
              onMouseLeave: function onMouseLeave() {
                setScrollOff(false);
                if (typeof onItemHover !== 'undefined') onItemHover(index);
              },
              onFocus: function onFocus() {
                if (typeof onItemHover !== 'undefined') onItemHover(index);
              }
            }, value), index)
          }, index);
        })
      }), searchResult[selectedItem] && /*#__PURE__*/_jsxs(Preview, {
        href: searchResult[selectedItem].href,
        title: searchResult[selectedItem].title,
        onClick: function onClick(e) {
          if (onSelectTemplate) {
            e.preventDefault();
            onSelectTemplate(searchResult[selectedItem]);
          }
        },
        children: [/*#__PURE__*/_jsx(Box, {
          $styles: {
            position: 'relative',
            width: 96,
            height: 62,
            marginBottom: 22
          },
          children: /*#__PURE__*/_jsx(LazyImage, {
            lazyload: false,
            detectIntersection: false,
            width: 96,
            height: 62,
            name: searchResult[selectedItem].title,
            original: {
              '*': searchResult[selectedItem].preview
            }
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "div",
          $variant: "p1medium",
          $mb: 8,
          children: searchResult[selectedItem].title
        }), /*#__PURE__*/_jsx(Text, {
          $variant: "p2",
          children: searchResult[selectedItem].description
        })]
      })]
    }), searchResult.length === 0 && isSearching && /*#__PURE__*/_jsx(NoResult, {
      children: statusMessages.SEARCHING
    }), !isSearching && searchString.length >= 3 && searchResult.length == 0 && /*#__PURE__*/_jsx(NoResult, {
      children: statusMessages.NO_RESULT
    }), !isSearching && searchString.length < 3 && searchResult.length == 0 && /*#__PURE__*/_jsx(NoResult, {
      children: statusMessages.TYPE_MORE
    })]
  });
};

export default SearchDropdown;